// extracted by mini-css-extract-plugin
export var dividerContainer = "_9u-0";
export var line = "_9u-1";